import { ProductImageModel } from './productImage.model';
import { DimensionItemDetailModel } from './dimensionItemDetail.model';
import { CommentProductModel } from './commentProduct.model';
import { ProductFamilyService } from '@shared/service/productFamily.service';
import { DimensionItemModel } from './dimensionItem.model';
import { Injectable } from '@angular/core';
import { AnyCnameRecord } from 'dns';
import { ShoppingCartModel } from './shoppingCart.model';
import { utiles } from '@utl/environment';
import { ShoppingCartLineModel } from './shoppingCartLine.model';
import { ItemService } from '@shared/service/items.service';
import { MatDialog } from '@angular/material/dialog';
import { CommonService } from '@shared/service/common.service';

@Injectable()

export class ItemInformationModel {
    ItemId: string;
    ItemName: string;
    Utilization: string;
    Unit: string;
    FamilyId: string;
    ItemWeight: number;
    Rating: number;
    PreviewPrice: number;
    Favorite: number;
    vImageList: string;
    vDimensionDetails: DimensionItemDetailModel[];
    SinglePrice: number;
    AllowComment: number;
    TotalRow: number;
    ImageList: any;
    ItemRating: number;
    ImageUrl: any;
    CommentUserInfo: CommentProductModel[];
    DiscountAmount: number;
    IsNewProduct: number;
    IsMasterProduct: number;
    UnitMesure: string;
    // EXT ABR 30-06-2020
    DiscountPercent: number;
    // EXT ABR 30-06-2020
    // KFSC - 27-04-2021
    PreviousPrice: number;
    Color: string;
    Style: string;
    Size: string;
    Config: string;
    KitItem: boolean;
    IsPromoItem: number;
    Qty: number;
    //==================
    //KFSC - 30-03-2022
    CustAccount: string;
    ProjectId: string;
    Currency: string;
    UserId: number;
    //=================
    ProductByFamily: any;
    //JSM 4-10-2022
    Alias: string;
    OnlyQuotProcess: boolean;
    constructor() {
        this.UnitMesure = '';
        this.ItemId = '';
        this.ItemName = '';
        this.Utilization = '';
        this.Unit = '';
        this.FamilyId = '';
        this.ItemWeight = 0;
        this.Rating = 0;
        this.PreviewPrice = 0;
        this.Favorite = 0;
        this.vImageList = '';
        this.vDimensionDetails = [];
        this.SinglePrice = 0;
        this.AllowComment = 0;
        this.TotalRow = 0;
        this.ImageList = [];
        this.ImageUrl = [];
        this.ItemRating = 0;
        this.CommentUserInfo = [];
        this.DiscountAmount = 0;
        this.IsNewProduct = 0;
        this.IsMasterProduct = 0;
        this.DiscountPercent = 0;
        this.PreviousPrice = 0;
        this.Color = '';
        this.Style = '';
        this.Size = '';
        this.Config = '';
        this.IsPromoItem = 0;
        this.Qty = 1;
        this.Currency = '';
        this.CustAccount = '';
        this.ProjectId = '';
        this.UserId = 0;
        this.Alias = '';
        this.OnlyQuotProcess = false;
    }

    ConsultarInformacion(productFamilyService: ProductFamilyService) {

      let itemDimension = new DimensionItemModel();
      itemDimension.Color = this.Color;
      itemDimension.Style = this.Style;
      itemDimension.Size = this.Size
      itemDimension.configId = this.Config;
      itemDimension.Currency = this.Currency;
      itemDimension.CustAccount = this.CustAccount;
      itemDimension.ProjectId = this.ProjectId;
      itemDimension.UserId = this.UserId;
      itemDimension.ItemId = this.ItemId;

      return productFamilyService.getDisplayItemDetail(itemDimension);
    }

    ObtenerPrecio() {

    }

    ObtenerDescuento() {

    }

    async AgregarCarrito(ItemService: ItemService, dialog: MatDialog, _common: CommonService) {
      let addressModel = utiles.getCacheSelectedAddress();

      let item = new ItemInformationModel();
      item.ItemId = this.ItemId;
      item.Color = this.Color;
      item.Style = this.Style;
      item.Size = this.Size;
      item.Config = this.Config;

      let shoppingCartLine = new ShoppingCartLineModel();
      shoppingCartLine.Item.push(item);
      shoppingCartLine.Quantity = this.Qty;

      let shoppingCart = new ShoppingCartModel(this.UserId, this.CustAccount, this.ProjectId, addressModel.DeliveryPostalAddressId, addressModel.SiteIdDelivery, this.Currency);
      await shoppingCart.insertarLinea(ItemService, shoppingCartLine, dialog, _common);
    }
}
